import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import { loading, tokens, select_style, success, alert, toFixed, GET, DELETE, format_date, getStorage, fieldSorter, total, roundToTwo, calculate_water } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import { Modal } from "react-bootstrap";

// ค่า source_menu ของใบเสร็จ (ตรงกับ Record_receipt.source_menu ฝั่ง backend)
// หน้านี้โชว์ป้ายที่มาเฉพาะใบที่ออกจากหน้าปรับปรุงใบเสร็จรับเงินเท่านั้น
const SOURCE_RECEIPT_ADJUSTMENT = "receipt-adjustment";


const role = getStorage("role_detail");
const select_role = role?.find((item) => item.name === "usage-history");
const view_r = select_role?.role[0] === 1;
const delete_r = select_role?.role[3] === 1;

export default class UsageHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_delete: false,
      page: 1,
      filter_address_number: null,
      data: null,
      data_address: null,
      record_receipt_id: "",
      delete_remark: "",
      address_number: ""
    };
  }

  async componentDidMount() {
    if (view_r) {
      loading(true)
      await Promise.all([this.GetAll(), this.GetAddressAll()]);
      loading(false)
    }
  }

  GetAddressAll = async () => {
    let result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) {
      this.setState({ data_address: result.data.data.map(item => ({ value: item.address_number, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) });
    }
  };

  GetAll = async () => {
    let data = { address_number: this.state.filter_address_number?.value || "" };
    let result = await GET(tokens, `v1/TH/record-receipt/history/filter-search/page/${this.state.page}/${getStorage("project_id")}`, data);
    
    if (result?.status) {
      let array = result.data;
      array.data.forEach((item) => {
        // ฟังก์ชันช่วยเช็คค่า s_xxx ถ้าเป็น false ให้คืน 0 ถ้า true คืนค่าเงิน
        const val = (key, sKey) => item[sKey] === false ? 0 : (item[key] || 0);
        item.total_amount = 
          val("add_debt", "s_add_debt") + val("cable_cost", "s_cable_cost") + val("common_expenses", "s_common_expenses") +
          val("equipment_maintenance_fee", "s_equipment_maintenance_fee") + val("fire_cost", "s_fire_cost") + val("late_payment", "s_late_payment") +
          val("meter_connect_cost", "s_meter_connect_cost") + val("other_income", "s_other_income") + val("waste_cost", "s_waste_cost") +
          val("water_bill", "s_water_bill") - val("reduce_debt", "s_reduce_debt") + (item.record_other_list?.[0]?.cost || 0);
      });
       for (let item of array.data) {
                          if(item.transaction_payments?.length > 0) {
                            // s_add_debt
                          // s_cable_cost
                          // s_common_expenses
                          // s_equipment_maintenance_fee
                          // s_fire_cost
                          // s_late_payment
                          // s_meter_connect_cost
                          // s_other_income
                          // s_reduce_debt
                          // s_waste_cost
                          // s_water_bill
                          console.log("A:", item.transaction_payments);
                            if(item.transaction_payments.some(p => p.s_water_bill)) {
                              console.log("A:", total(item.transaction_payments.filter(p => p.s_water_bill),"water_bill"));
                              item.water_bill = total(item.transaction_payments.filter(p => p.s_water_bill),"water_bill");
                            }else{
                              item.water_bill = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_waste_cost)) {
                              item.waste_cost = total(item.transaction_payments.filter(p => p.s_waste_cost),"waste_cost");
                            }else{
                              item.waste_cost = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_reduce_debt)) {
                              item.reduce_debt = total(item.transaction_payments.filter(p => p.s_reduce_debt),"reduce_debt");
                            }else{
                              item.reduce_debt = 0;
                            }
                  
                            if(item.transaction_payments.some(p => p.s_other_income)) {
                              item.other_income = total(item.transaction_payments.filter(p => p.s_other_income),"other_income");
                            }else{
                              item.other_income = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_meter_connect_cost)) {
                              item.meter_connect_cost = total(item.transaction_payments.filter(p => p.s_meter_connect_cost),"meter_connect_cost");
                            } else{
                              item.meter_connect_cost = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_late_payment)) {
                              item.total_cost_late = total(item.transaction_payments.filter(p => p.s_late_payment),"total_cost_late");
                            } else {
                              item.total_cost_late = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_fire_cost)) {
                              item.fire_cost = total(item.transaction_payments.filter(p => p.s_fire_cost),"fire_cost");
                            } else {
                              item.fire_cost = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_equipment_maintenance_fee)) {
                              item.equipment_maintenance_fee = total(item.transaction_payments.filter(p => p.s_equipment_maintenance_fee),"equipment_maintenance_fee");
                            } else {
                              item.equipment_maintenance_fee = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_common_expenses)) {
                              item.common_expenses = total(item.transaction_payments.filter(p => p.s_common_expenses),"common_expenses");
                            } else {
                              item.common_expenses = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_cable_cost)) {
                              item.cable_cost = total(item.transaction_payments.filter(p => p.s_cable_cost),"cable_cost");
                            } else {
                              item.cable_cost = 0;
                            }
                            if(item.transaction_payments.some(p => p.s_add_debt)) {
                              item.add_debt = total(item.transaction_payments.filter(p => p.s_add_debt),"add_debt");
                            } else {
                              item.add_debt = 0;
                            }
                            item.total_amount = item.water_bill + item.waste_cost + item.other_income + item.meter_connect_cost + item.total_cost_late + item.fire_cost + item.equipment_maintenance_fee + item.common_expenses + item.cable_cost + item.add_debt - item.reduce_debt;
                          }else{
                            item.total_cost_late = item.s_late_payment ? (item.total_cost_late || item.late_payment || 0) : 0;
                            let res = await GET(tokens, `v1/TH/record-receipt/history/by-iw-number/${getStorage("project_id")}`, { iw_number: item.iw_number });
                            console.log("res:", res);
                          }
                        }
      this.setState({ data: array });
    }
  };

  Delete = async () => {
    loading(true)
    let result = await DELETE(tokens, `v1/TH/bill-water-group/delete/${this.state.record_receipt_id}`, { delete_remark: this.state.delete_remark });
    if (result?.status) {
      if(this.state.address_number){
        await calculate_water(this.state.address_number);
      }
      this.clear_form();
      success();
      this.GetAll();
    }
    loading(false)
  };

  clear_form = () => {
    this.setState({ modal_delete: false, page: 1, filter_address_number: null, record_receipt_id: "", delete_remark: "" });
  };

  Print = async (iw_number) => {
    loading(true)
    this.setState({ delete_remark: "" });
    try{
          const array_cost = [ "add_debt", "cable_cost", "common_expenses", "equipment_maintenance_fee", "fire_cost", "late_payment", "meter_connect_cost", "other_income", "reduce_debt", "waste_cost", "water_bill" ];
          let result = await GET(tokens, "v1/TH/record-receipt/history/by-iw-number/" + getStorage("project_id"), { iw_number });
          if (result?.status) {
            let data = result.data.data;

            console.log("data:", data);
            const baseHeader = {
              project_name: getStorage("project_name"),
              project_address: `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ  ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`,
              cutomer_name: data.full_name,
              cutomer_address: data.address || data.address_number,
              number: data.iw_number,
              date: format_date(data.record_date, "dd mmmm yyyy"),
              payment: data.payment_type === 1 ? "เงินสด" : "โอนเงินเข้าบัญชีนิติฯ",
              payment_date: `${format_date(data.transfer_date || data.record_date, "dd/mm/yyyy")} เวลา ${(data.transfer_time || data.record_time)?.slice(0, 5)}`
            };
    
            if (data?.record_other_list.length !== 0) {
              // ใบเสร็จอื่นๆ
              localStorage.setItem("DATA_", JSON.stringify({
                ...baseHeader, 
                title: data.record_other_list?.[0]?.title, 
                description: data.record_other_list?.[0]?.description,
                cost: data.record_other_list?.[0]?.cost, 
                total: data.record_other_list?.[0]?.cost, 
                change_satang: 0,
              }));
              window.open("/doc/receipt-other", "_blank");
            } else {
              // ใบเสร็จน้ำ
              if(data.transaction_payments.length > 0) {
                data.transaction_payments = data.transaction_payments.map((item) => ({
                  ...item,
                  datetime_create: data.water_list?.find((e) => e.record_water_id === item.record_water_id)?.datetime_create || item.datetime_create,
                }))
              }
              data.water_receipt_list = data.transaction_payments.length > 0 ? data.transaction_payments : data.water_list;
              data.water_receipt_list = data.water_receipt_list.sort((a, b) => new Date(b.datetime_create) - new Date(a.datetime_create));
              const getP = (type) => {
                const src = data.water_receipt_list[0];
                return src?.[`s_${type}`] ? (type === "late_payment" ? (src["total_cost_late"] ?? src["late_payment"]) : src[type]) : 0;
              }
              const getT = (item) => {
                let past_total = 0;
                array_cost.map(type => {
                  if(type === "reduce_debt"){
                    past_total -= total(item.filter(e=>e[`s_${type}`]), type);
                  }else if(type === "late_payment"){
                    past_total += item.filter(e=>e[`s_${type}`]).reduce((sum, e) => sum + (e.total_cost_late ?? e.late_payment ?? 0), 0);
                  }else {
                    past_total += total(item.filter(e=>e[`s_${type}`]),type);
                  }
                })
                return parseFloat(past_total.toFixed(2));;
              }
              const water_list_price = getT(data.water_receipt_list.filter((e,i) => i !== 0)); //ค่าใช้จ่าย เดือนก่อนหน้า
              const total_calc = water_list_price + getT(data.water_receipt_list.filter((e,i) => i === 0)) + data.add_on_add_debt - data.add_on_reduce_debt; //รวมทั้งสิ้น
      
              console.log("water_list_price:",water_list_price)
              console.log("total_calc:",total_calc)
      
              const lastMonth = new Date(data.last_date);
              lastMonth.setMonth(lastMonth.getMonth() - 1);
      
              let data_print = {
                ...baseHeader,
                water_current_month: data.last_date,
                water_last_month: data.brefore_last_date !== data.last_date ? data.brefore_last_date : format_date(lastMonth, "yyyy-mm-dd", "en"),
                last_gauge_number: data.last_gauge_number,
                current_gauge_number: data.current_gauge_number,
                unit_used: data.unit_used,
                water_bill: getP("water_bill"),
                equipment_maintenance_fee: getP("equipment_maintenance_fee"),
                waste_cost: getP("waste_cost"),
                common_expenses: getP("common_expenses"),
                water_list: data.water_receipt_list || [],
                water_list_price,
                // ตัวเลขแสดงผลเท่านั้น (ไม่เข้า water_list_price/total) = ค่าต่อกลับมิเตอร์งวดปัจจุบัน + งวดค้างที่ s_meter_connect_cost=true เหมือน New Print (RecordReceipt.js)
                meter_connect_cost: getP("meter_connect_cost") + total(data.water_receipt_list.filter((e, i) => i !== 0 && e.s_meter_connect_cost), "meter_connect_cost"),
                total_cost_late: getP("late_payment"),
                fire_cost: getP("fire_cost"),
                cable_cost: getP("cable_cost"),
                other_income: getP("other_income"),
                add_debt: getP("add_debt"),
                add_on_add_debt: data.add_on_add_debt,
                reduce_debt: getP("reduce_debt"),
                add_on_reduce_debt: data.add_on_reduce_debt,
                total: total_calc,
                change_satang: data.change_satang,
              };
      
              console.log("data_print:", data_print);
      
              localStorage.setItem("DATA_", JSON.stringify(data_print));
              window.open("/doc/receipt", "_blank");
            }
          } else {
            alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
            this.clear_form();
          }
        }catch(e){
          console.log(e);
          alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
        }
    loading(false)
  };

  render() {
    // Helper function ช่วยเช็ค s_ และแสดงผลตัวเลข (ถ้ายกเลิกชำระแสดงเป็น 0.00)
    const showVal = (val, sFlag) => sFlag === false ? "0.00" : toFixed(val || 0);

    return (
        <div className="w-100 min-vh-100 fade-in">
            {this.state.loading && (
                <div className="spinner-container">
                    <div className="loading-spinner"></div>
                </div>
            )}
            <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ประวัติค่าใช้จ่าย" />

            <div className="body">
                <div className="p-3">
                    <div className="card border-0 p-3">
                        <div className="d-flex row mx-0 align-items-center justify-content-between">
                            <h4 className="mb-3">
                                <b>ประวัติค่าใช้จ่าย</b>
                            </h4>
                        </div>

                        {view_r && (
                            <div className="d-flex row mx-0 align-items-center justify-content-between">
                                <div className="d-flex row mx-0">
                                    <Select
                                        className="form-control bg-contain border-0 select-search wpx-200 mb-3 mx-1"
                                        styles={select_style}
                                        options={this.state.data_address || []}
                                        onChange={(e) => this.setState({ filter_address_number: e })}
                                        value={this.state.filter_address_number}
                                    />
                                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                                        ค้นหา
                                    </button>
                                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>
                                        รีเซ็ท
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="table-responsive">
                            <table className="table table-borderless table-striped text-nowrap">
                                <thead>
                                    <tr className="bg-dark-blue text-white">
                                        <th className="text-left">เลขที่ใบเสร็จ</th>
                                        <th className="text-left">วันที่ใบเสร็จ</th>
                                        <th className="text-left">บ้านเลขที่</th>
                                        <th className="text-left">จำนวนหน่วยที่ใช้</th>
                                        <th className="text-right">ค่าน้ำประปา</th>
                                        <th className="text-right">ค่ารักษาอุปกรณ์น้ำ</th>
                                        <th className="text-right">ค่าส่วนกลาง</th>
                                        <th className="text-right">ค่าขยะ</th>
                                        <th className="text-right">ค่าเคเบิล</th>
                                        <th className="text-right">ค่าเบี้ยประกัน</th>
                                        <th className="text-right">รายการอื่นๆ</th>
                                        <th className="text-right">เพิ่ม/ลดหนี้</th>
                                        <th className="text-right">ค่าปรับล่าช้า</th>
                                        <th className="text-right">ปรับปรุงยอดเงิน</th>
                                        <th className="text-right">รวมเป็นเงิน</th>
                                        {delete_r && <th className="text-center">ยกเลิกรายการ</th>}
                                        <th className="text-center">พิมพ์ใบเสร็จ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!this.state.data?.data?.length ? (
                                        <tr>
                                            <td colSpan={16} className="text-center">
                                                ไม่มีข้อมูล
                                            </td>
                                        </tr>
                                    ) : (
                                        this.state.data.data.map((item, index) => {
                                            // คำนวณยอด หนี้สิน ก่อนแสดงผล (เช็ค s_ ของหนี้แต่ละตัว)
                                            const addD = item.s_add_debt === false ? 0 : (item.add_debt || 0) + (item.add_on_add_debt || 0);
                                            const redD = item.s_reduce_debt === false ? 0 : (item.reduce_debt || 0) + (item.add_on_reduce_debt || 0);
                                            // คำนวณรายได้อื่นๆ (ถ้าเป็นบิลรับรายได้อื่น ให้ดึงราคาจากลิสต์ก่อน)
                                            const otherCost = item.record_other_list?.[0]?.cost;

                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {item.iw_number || "-"}
                                                        {item.source_menu === SOURCE_RECEIPT_ADJUSTMENT && (
                                                            <span className="src-tag" title="ปรับปรุงใบเสร็จรับเงิน">
                                                                &#9432;
                                                                <span className="src-tag__pop">ที่มา: ปรับปรุงใบเสร็จรับเงิน</span>
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>{item.record_date ? format_date(item.record_date, "dd/mm/yyyy") : "-"}</td>
                                                    <td className="text-right">{item.address_number || item.address || "-"}</td>
                                                    <td className="text-right">{item.sum_unit_used || "0"}</td>
                                                    <td className="text-right">{showVal(item.water_bill, item.s_water_bill)}</td>
                                                    <td className="text-right">{showVal(item.equipment_maintenance_fee, item.s_equipment_maintenance_fee)}</td>
                                                    <td className="text-right">{showVal(item.common_expenses, item.s_common_expenses)}</td>
                                                    <td className="text-right">{showVal(item.waste_cost, item.s_waste_cost)}</td>
                                                    <td className="text-right">{showVal(item.cable_cost, item.s_cable_cost)}</td>
                                                    <td className="text-right">{showVal(item.fire_cost, item.s_fire_cost)}</td>
                                                    <td className="text-right">{otherCost !== undefined ? toFixed(otherCost) : showVal(item.other_income, item.s_other_income)}</td>
                                                    <td className="text-right">{toFixed(addD - redD)}</td>
                                                    <td className="text-right">{toFixed(item.total_cost_late || 0)}</td>
                                                    <td className="text-right">{toFixed(item.change_satang || 0)}</td>
                                                    <td className="text-right">
                                                        {toFixed(item.record_other_list?.[0]?.cost && !item.total_final ? item.record_other_list[0].cost : item.total_final || item.total_amount)}
                                                    </td>
                                                    {delete_r && (
                                                        <td className="text-center">
                                                            {item.status_bill === 1 ? (
                                                                <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0">
                                                                    <label
                                                                        className="icon mx-2 text-danger pointer"
                                                                        onClick={() =>
                                                                            this.setState({ modal_delete: true, record_receipt_id: item.record_receipt_id, address_number: item.address_number })
                                                                        }
                                                                    >
                                                                        {"\uf2ed"}
                                                                    </label>
                                                                </label>
                                                            ) : (
                                                                <label className="text-danger">ยกเลิกแล้ว</label>
                                                            )}
                                                        </td>
                                                    )}
                                                    <td className="text-center">
                                                        {item.status_bill === 1 && (
                                                            <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0">
                                                                <label className="icon mx-2 text-primary pointer" onClick={() => this.Print(item.iw_number)}>
                                                                    {"\uf02f"}
                                                                </label>
                                                            </label>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {this.state.data?.data?.length > 0 && (
                            <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                                <div>
                                    <label>
                                        แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                    </label>
                                </div>
                                <Pagination
                                    count={this.state.data.page_number}
                                    page={this.state.page}
                                    color="primary"
                                    showFirstButton
                                    showLastButton
                                    onChange={(e, value) => this.setState({ page: value }, () => this.GetAll())}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal Delete */}
            <Modal show={this.state.modal_delete} onHide={() => this.setState({ modal_delete: false })}>
                <Modal.Header>
                    <Modal.Title>
                        <b>ยืนยันการลบประวัติค่าใช้จ่าย</b>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="w-100 d-flex mb-3">
                        <label>ท่านแน่ใจว่าต้องการลบข้อมูลลูกค้า หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label>
                    </div>
                    <input
                        className="form-control border-0 bg-contain mb-3"
                        type="text"
                        placeholder="หมายเหตุยกเลิก (ถ้ามี)"
                        value={this.state.delete_remark}
                        onChange={(e) => this.setState({ delete_remark: e.target.value })}
                    />
                    <div className="w-100 d-flex">
                        <div className="w-50 p-1">
                            <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_delete: false })}>
                                ยกเลิก
                            </button>
                        </div>
                        <div className="w-50 p-1">
                            <button className="btn btn-danger w-100" onClick={this.Delete}>
                                ยืนยัน
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
  }
}